// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { RadioButtonProps } from '../internal/components/radio-button/interfaces';

export { RadioButtonProps };
